<svelte:head>
	<title>About - OS Studio</title>
	<meta name="description" content="Learn about OS Studio and our mission to democratize operating system development." />
</svelte:head>

<div class="min-h-screen bg-white">
	<!-- Hero -->
	<div class="bg-gradient-to-br from-purple-900 to-blue-900 text-white py-20">
		<div class="container mx-auto px-4 max-w-6xl text-center">
			<h1 class="text-5xl font-bold mb-4">About OS Studio</h1>
			<p class="text-xl text-purple-100">Building the future of operating systems, one AI conversation at a time</p>
		</div>
	</div>

	<!-- Mission -->
	<div class="container mx-auto px-4 max-w-6xl py-20">
		<div class="grid grid-cols-1 md:grid-cols-2 gap-12 items-center mb-20">
			<div>
				<h2 class="text-4xl font-bold text-gray-900 mb-6">Our Mission</h2>
				<p class="text-lg text-gray-600 mb-4">
					We believe that building operating systems should be accessible to everyone. Not just large enterprises with unlimited budgets.
				</p>
				<p class="text-lg text-gray-600 mb-4">
					OS Studio democratizes system development by combining the power of AI with intuitive conversation. We're making the process 10x faster and 10x more affordable.
				</p>
			</div>
			<div class="bg-gradient-to-br from-purple-500 to-blue-500 rounded-lg h-64"></div>
		</div>

		<!-- Values -->
		<div class="py-20 border-t border-gray-200">
			<h2 class="text-4xl font-bold text-gray-900 mb-12 text-center">Our Values</h2>
			<div class="grid grid-cols-1 md:grid-cols-3 gap-8">
				<div class="text-center">
					<div class="text-4xl mb-4">⚡</div>
					<h3 class="text-xl font-bold text-gray-900 mb-2">Speed</h3>
					<p class="text-gray-600">From conversation to production in hours, not months</p>
				</div>
				<div class="text-center">
					<div class="text-4xl mb-4">🔐</div>
					<h3 class="text-xl font-bold text-gray-900 mb-2">Security</h3>
					<p class="text-gray-600">Enterprise-grade security built into every system</p>
				</div>
				<div class="text-center">
					<div class="text-4xl mb-4">🎯</div>
					<h3 class="text-xl font-bold text-gray-900 mb-2">Simplicity</h3>
					<p class="text-gray-600">Complex technology made simple through conversation</p>
				</div>
			</div>
		</div>

		<!-- Team -->
		<div class="py-20 border-t border-gray-200">
			<h2 class="text-4xl font-bold text-gray-900 mb-12 text-center">Our Team</h2>
			<p class="text-center text-gray-600 text-lg mb-12 max-w-2xl mx-auto">
				Built by engineers, architects, and builders who believe in the power of AI to solve the hardest problems in software.
			</p>
			<div class="text-center text-gray-600">
				<p>Hundreds of developers worldwide collaborating to build the future.</p>
			</div>
		</div>
	</div>
</div>
